module.exports = __webpack_public_path__ + "static/media/northern.27e717ef.png";